import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";

export const AppShell = ({ children, user, onLogout }) => (
  <div className="grid-soft min-h-screen bg-zinc-50 text-zinc-900 md:block" data-testid="app-shell">
    <Sidebar user={user} />
    <div className="md:ml-64">
      <Topbar onLogout={onLogout} user={user} />
      <main className="page-shell px-4 pb-10 pt-5 md:px-8 md:pb-12 md:pt-8" data-testid="app-page-content">
        {children}
      </main>
    </div>
  </div>
);